module.exports = __webpack_public_path__ + "media/rendering/renderingSlide2-9e7076ff.png";